import redux from '../../assets/stacklogo/redux.svg';

export default function Redux(){
    return(
        <img src={redux} alt="" srcset="" />
    )
}